// Gestionnaire d'étiquettes (task_labels) : créer / renommer / couleur+emoji /
// supprimer. À la suppression, le parent retire le label des admin_tasks.labels.

import { useState } from 'react'
import { DS } from '../../lib/ui'

const DEFAULT_COLORS = ['#3d5166', '#87b8e6', '#C17B5C', '#2d7a3a', '#d97706', '#e11d48', '#7c3aed', '#0284c7']

export default function LabelManager({ labels, onCreate, onUpdate, onDelete, onClose }) {
  const [name, setName] = useState('')
  const [emoji, setEmoji] = useState('')
  const [color, setColor] = useState('#3d5166')
  const [busy, setBusy] = useState(false)

  const handleCreate = async () => {
    if (!name.trim()) return
    setBusy(true)
    const ok = await onCreate({ name: name.trim(), emoji: emoji.trim() || null, color })
    setBusy(false)
    if (ok) { setName(''); setEmoji(''); setColor('#3d5166') }
  }

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', zIndex: 1001, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
      onClick={onClose}
    >
      <div
        onClick={e => e.stopPropagation()}
        className="fbz-modal-sheet"
        style={{ background: DS.white, borderRadius: 16, padding: 24, maxWidth: 460, width: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 16px 48px rgba(0,0,0,.22)', fontFamily: DS.fontBody }}
      >
        <div style={{ fontFamily: DS.fontDisplay, fontWeight: 600, fontSize: 18, color: DS.marineDark, marginBottom: 14 }}>
          Gérer les étiquettes
        </div>

        {/* Création */}
        <div style={{ background: '#f1f2f4', borderRadius: 10, padding: 12, marginBottom: 16 }}>
          <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
            <input value={emoji} onChange={e => setEmoji(e.target.value)} placeholder="🏷" maxLength={4}
              style={{ ...inputStyle, width: 56, textAlign: 'center' }} data-testid="label-emoji" />
            <input value={name} onChange={e => setName(e.target.value)} placeholder="Nom de l'étiquette"
              style={{ ...inputStyle, flex: 1 }} data-testid="label-name" />
          </div>
          <div style={{ display: 'flex', gap: 6, marginBottom: 10, flexWrap: 'wrap' }}>
            {DEFAULT_COLORS.map(c => (
              <button key={c} type="button" onClick={() => setColor(c)}
                style={{ width: 24, height: 24, borderRadius: '50%', background: c, cursor: 'pointer',
                  border: color === c ? `3px solid ${DS.navy}` : '2px solid #fff', boxShadow: '0 0 0 1px #ccd' }} />
            ))}
          </div>
          <button type="button" onClick={handleCreate} disabled={!name.trim() || busy}
            style={{ ...primaryBtn, opacity: !name.trim() || busy ? 0.5 : 1 }} data-testid="label-create">
            + Créer
          </button>
        </div>

        {/* Liste */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {labels.length === 0 && <span style={{ fontSize: 13, color: DS.textLight }}>Aucune étiquette</span>}
          {labels.map(l => (
            <LabelRow key={l.id} label={l} onUpdate={onUpdate} onDelete={onDelete} />
          ))}
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 18 }}>
          <button type="button" onClick={onClose} style={ghostBtn}>Fermer</button>
        </div>
      </div>
    </div>
  )
}

function LabelRow({ label, onUpdate, onDelete }) {
  const [editing, setEditing] = useState(false)
  const [name, setName] = useState(label.name)
  const [emoji, setEmoji] = useState(label.emoji || '')
  const [color, setColor] = useState(label.color)

  const save = async () => {
    if (!name.trim()) return
    const ok = await onUpdate(label.id, { name: name.trim(), emoji: emoji.trim() || null, color })
    if (ok) setEditing(false)
  }

  if (editing) {
    return (
      <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
        <input value={emoji} onChange={e => setEmoji(e.target.value)} maxLength={4} style={{ ...inputStyle, width: 48, textAlign: 'center' }} />
        <input value={name} onChange={e => setName(e.target.value)} style={{ ...inputStyle, flex: '1 1 120px', minWidth: 0 }} />
        <div style={{ display: 'flex', gap: 4 }}>
          {DEFAULT_COLORS.map(c => (
            <button key={c} type="button" onClick={() => setColor(c)}
              style={{ width: 18, height: 18, borderRadius: '50%', background: c, cursor: 'pointer',
                border: color === c ? `2px solid ${DS.navy}` : '1px solid #fff', boxShadow: '0 0 0 1px #ccd' }} />
          ))}
        </div>
        <button type="button" onClick={save} style={{ ...primaryBtn, padding: '4px 10px' }}>OK</button>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, padding: '6px 8px', borderRadius: 8, border: '1px solid #eef' }}>
      <span style={{ fontSize: 13, fontWeight: 600, padding: '2px 10px', borderRadius: 10, background: `${label.color}22`, color: label.color, border: `1px solid ${label.color}55` }}>
        {label.emoji ? `${label.emoji} ` : ''}{label.name}
      </span>
      <div style={{ display: 'flex', gap: 6 }}>
        <button type="button" onClick={() => setEditing(true)} style={miniBtn}>Modifier</button>
        <button type="button" onClick={() => onDelete(label)} style={{ ...miniBtn, color: DS.charge }} data-testid="label-delete">Supprimer</button>
      </div>
    </div>
  )
}

const inputStyle = { padding: '8px 10px', borderRadius: DS.radiusControl, border: `0.5px solid ${DS.borderHover}`, fontSize: 14, fontFamily: DS.fontBody, color: DS.marineDark, boxSizing: 'border-box' }
const ghostBtn = { fontSize: 13, fontWeight: 600, padding: '9px 15px', borderRadius: DS.radiusControl, border: `0.5px solid ${DS.borderHover}`, background: DS.card, color: DS.marine, cursor: 'pointer', fontFamily: DS.fontBody }
const primaryBtn = { fontSize: 13, fontWeight: 600, padding: '9px 16px', borderRadius: DS.radiusControl, border: 'none', background: DS.corail, color: '#fff', cursor: 'pointer', fontFamily: DS.fontBody }
const miniBtn = { fontSize: 12, fontWeight: 600, padding: '4px 9px', borderRadius: 7, border: `0.5px solid ${DS.border}`, background: DS.card, color: DS.marine, cursor: 'pointer', fontFamily: DS.fontBody }
